import apiClient from '../../session/apiClient'

export function search(q) {
  return apiClient.get('/location/address/search', { params: { q }}).then(x => x.data.results)
}


/**
 *
 * @typedef {Object}     countrySettings
 * @property {string}    countrySettings.id
 * @property {string}    countrySettings.name
 * @property {*}         countrySettings.settings
 */


/**
 *
 * @return {Promise.<countrySettings[]>}
 */
export function listCountries() {
  return apiClient.get('/location/address/countries').then(x => {
    return x.data.countries
  })
}